import React, { Component } from 'react';
import './App.css';
import {
  Button,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import PictureEditor from './PictureEditor';
import DragHandler from './DragHandler';
import logo from './logo_800x800_transparent.png';

class App extends Component {
  constructor(props) {
    super(props);
    this.handleMoveUpEditor = this.handleMoveUpEditor.bind(this);
    this.handleMoveDownEditor = this.handleMoveDownEditor.bind(this);
    this.handleRemoveEditor = this.handleRemoveEditor.bind(this);
    this.handleAddNewEditor = this
      .handleAddNewEditor
      .bind(this);
    this.state = {
      json: '',
      showJson: false,
      editors: [
        {
          key: Date.now(),
          ref: React.createRef(),
        },
      ],
    };
  }

  componentDidMount() {
    DragHandler.initDraggable('.draggable');
  }

  handleAddNewEditor() {
    const { editors } = this.state;
    this.setState({
      editors: [
        ...editors, {
          key: Date.now(),
          ref: React.createRef(),
        },
      ],
    });
  }

  generateJson() {
    const json = [];
    const { editors } = this.state;

    editors.forEach(({ ref }) => {
      console.log(ref);
      json.push(ref.current.generateJson());
    });
    return JSON.stringify(json);
  }

  handleShowJson() {
    this.setState({
      json: this.generateJson(),
      showJson: true,
    });
  }

  findEditorPosByNum(editorNum) {
    const { editors } = this.state;

    for (let index = 0; index < editors.length; index++) {
      if (editors[index].key === editorNum) {
        return index;
      }
    }
  }

  handleMoveUpEditor(editorNum) {
    const index = this.findEditorPosByNum(editorNum);
    if (index === 0) {
      return;
    }
    const { editors } = this.state;
    const temp = editors[index - 1];
    editors[index - 1] = editors[index];
    editors[index] = temp;

    this.setState({
      editors,
    });
  }

  handleRemoveEditor(editorKey) {
    const index = this.findEditorPosByNum(editorKey);
    const { editors } = this.state;
    editors.splice(index, 1);
    this.setState({
      editors,
    });
  }

  handleMoveDownEditor(editorNum) {
    const index = this.findEditorPosByNum(editorNum);
    const { editors } = this.state;
    if (index === editors.length - 1) {
      return;
    }
    const temp = editors[index + 1];
    editors[index + 1] = editors[index];
    editors[index] = temp;

    this.setState({
      editors,
    });
  }

  handleCloseJson() {
    this.setState({ showJson: false });
  }

  render() {
    const { editors, showJson, json } = this.state;
    const editorsDivs = [];
    for (let i = 0; i < editors.length; i += 1) {
      editorsDivs.push(
        <li key={editors[i].key}>
          <PictureEditor ref={editors[i].ref} num={editors[i].key} handleRemoveEditor={this.handleRemoveEditor} handleMoveDown={this.handleMoveDownEditor} handleMoveUp={this.handleMoveUpEditor} />
        </li>,
      );
    }
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h1 className="App-title">
            Générateur de code pour l'animation de survol.
          </h1>
          <p style={{ color: 'red', fontSize: '1.2rem' }}>
          Attention ! Vous devez écrire vos descriptions et titres dans un éditeur de texte avant de les rentrer sur cet outil. En effet, il n'y a pas de système de sauvegarde et donc vos textes pourrais être perdu. Les images sur le carousel du site et dans cet outil doivent être dans le même ordre.
          </p>
        </header>
        <div className="button-container">
          <Button variant="contained" size="large" onClick={this.handleAddNewEditor}>
            <Icon>
              add
            </Icon>
            Rajouter une image
          </Button>
          <Button
            variant="contained"
            size="large"
            color="primary"
            onClick={e => this.handleShowJson(e)}
          >
            <Icon>
              save_alt
            </Icon>
            Générer le code
          </Button>
        </div>
        <ul>
          {editorsDivs}
        </ul>
        <Dialog
          open={showJson}
          onClose={e => this.handleCloseJson(e)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {'Résultat génération du code'}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Ci-dessous, le code à copier-coller dans le champs correspondant sur votre
              interface de gestion de site.
            </DialogContentText>
            <textarea
              className="json-textarea"
              readOnly
              name="textarea"
              rows="10"
              cols="50"
              value={json}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={e => this.handleCloseJson(e)} color="primary">
              Fermer
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx